import {logger, redact} from './logger';
import {hasOwn} from '@pexip/utils';
import type {CreateFetcher, Logger} from './types';

const debugLogger: Logger = {
    log: (meta, msg) => logger.debug(meta, msg),
    redact: (text: string) => logger.redact(text),
};
const infoLogger: Logger = {
    log: (meta, msg) => logger.info(meta, msg),
    redact: (text: string) => logger.redact(text),
};

/**
 * Fetch with built-in logging the request and response
 */
const createFetcherWithLogging: CreateFetcher = log => async (input, init) => {
    const url = input instanceof Request ? input.url : input;
    const urlStr = log.redact(url.toString());
    const {headers: _, ...initWithoutHeaders} = init ?? {};
    log.log({init: initWithoutHeaders}, `Request [${urlStr}]`);
    const response = await window.fetch(input, init);
    const statusInfo = {
        status: response.status,
        statusText: response.statusText,
    };
    if (
        response.headers.get('content-type')?.startsWith('application/json') &&
        response.status !== 204
    ) {
        try {
            const clonedResponse = response.clone();
            const body = (await clonedResponse.json()) as unknown;
            if (body && hasOwn(body, 'result')) {
                redact(body.result, 'token');
                redact(body.result, 'conference_name');
            }
            log.log({...statusInfo, body}, `Response [${urlStr}]`);
            // Replay the response
            return response;
        } catch {
            return response;
        }
    } else {
        log.log(statusInfo, `Response [${urlStr}]`);
        return response;
    }
};

export const fetchWithDebugLog = createFetcherWithLogging(debugLogger);
export const fetchWithInfoLog = createFetcherWithLogging(infoLogger);
